document.querySelectorAll('nav.custom-nav').forEach((nav,navIndex)=>{
  if(!nav.querySelector('.vd-nav-toggle'))return;
  const closers=[];
  const items=[...nav.querySelectorAll('li')].filter(li=>li.querySelector(':scope > .sub-nav-box'));
  items.forEach((li,index)=>{
    const panel=li.querySelector(':scope > .sub-nav-box');
    const button=li.querySelector(':scope > .vd-nav-toggle');
    if(!button)return;
    let timer,hoverTimer,pinned=false;
    panel.id=`VD-Nav-${navIndex}-${index}`;button.setAttribute('aria-controls',panel.id);
    const set=open=>{clearTimeout(timer);clearTimeout(hoverTimer);li.classList.toggle('vd-nav-open',open);button.setAttribute('aria-expanded',String(open));if(!open)pinned=false;};
    const open=()=>{closers.forEach(close=>close(li));set(true);};
    closers.push(other=>{if(other!==li&&!li.contains(other))set(false);});
    button.addEventListener('click',()=>{if(pinned){set(false);}else{open();pinned=true;}});
    const link=li.querySelector(':scope > a');
    if(link?.getAttribute('href')==='#')link.addEventListener('click',event=>{event.preventDefault();open();pinned=true;});
    li.addEventListener('mouseenter',()=>{clearTimeout(timer);clearTimeout(hoverTimer);hoverTimer=setTimeout(open,150);});
    li.addEventListener('mouseleave',()=>{clearTimeout(hoverTimer);clearTimeout(timer);timer=setTimeout(()=>{if(!li.matches(':hover')&&!li.contains(document.activeElement))set(false);},350);});
    li.addEventListener('focusout',event=>{if(!li.contains(event.relatedTarget))set(false);});
    li.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();set(false);button.focus();}});
  });
  document.addEventListener('click',event=>{if(!nav.contains(event.target))closers.forEach(close=>close(null));});
  nav.classList.add('vd-nav-ready');
});

